export const REPORTS_LIST_QUERY_KEY = "reports";
export const REPORTS_FACET_QUERY_KEY = (id: string) => [
  "reports",
  id,
  "facets",
];
